import React from 'react';
import { Button, Table, Modal, Alert, FormControl, Row, Col } from 'react-bootstrap';
import { hashHistory } from 'react-router';
import { authContext } from '../AzureAd';
import RfidSettingContainer from '../containers/RfidSettingContainer.jsx';
import SearchMRecordListContainer from '../containers/SearchMRecordListContainer.jsx';
import MaintenanceSearchRecordContainer from '../containers/MaintenanceSearchRecordContainer.jsx';

export default class MaintenanceRfidComponent extends React.Component {
    operator = authContext.getCachedUser().userName;

    // constructor(props) {
    //     super(props);
    // }

    componentWillMount() {
        let reader = {
            name: localStorage.getItem('rfid.name'),
            hostname: localStorage.getItem('rfid.hostname'),
            port: localStorage.getItem('rfid.port'),
            sensitivity: localStorage.getItem('rfid.sensitivity'),
        }

        this.props.assignRfidReader(reader);
        this.props.reloadCurrentEpc(this.props.view.get('card'), this.props.request.get('category'));

        this.props.cleanRfidChips();
        this.props.changeShowInputLabelId(false);
        this.props.cleanSearchResult();
    }

    componentWillUnmount() {
		this.props.cleanAlert();
		this.props.cleanSearchResult();
	}

    readRfidChips() {
        this.props.cleanRfidChips();
        let reader = {
            name: localStorage.getItem('rfid.name'),
            hostname: localStorage.getItem('rfid.hostname'),
            port: localStorage.getItem('rfid.port'),
            sensitivity: localStorage.getItem('rfid.sensitivity'),
        }
        this.props.readRfidChips(reader);
    }

    show(show) {
        if (show) {
            return { display: 'block', float: 'left' };
        } else {
            return { display: 'none' };
        }
    }

    previousPage() {
        hashHistory.push("/maintenanceCard");
    }

    showRfidConfig() {
        this.props.cleanRfidChips();
        this.props.showRfidConfig();
    }

    assignRfidReader(speedway) {
        localStorage.setItem('rfid.name', speedway.name);
        localStorage.setItem('rfid.hostname', speedway.hostname);
        localStorage.setItem('rfid.port', speedway.port);
        localStorage.setItem('rfid.sensitivity', speedway.sensitivity);
        this.props.assignRfidReader(speedway);
    }

    currentSpeedway() {
        let reader = this.props.rfid.get("hostname");
        if (reader) {
            return "目前所選取的 RFID 讀取機為:";
        } else {
            return "目前尚未選取 RFID 讀取機";
        }
    }

    readerHighlight() {
        let reader = this.props.rfid.get("name");
        if (reader) {
            return <span className='highlight-B'>{reader}</span>;
        } else {
            return "";
        }
    }

    confirmEpc(epc) {
        let ret = true;
        let epcs = this.props.rfid.get('epcs');
        if (epcs && this.props.rfid.get('epcs').length > 1) {
            ret = confirm('目前讀取到多於一個EPC, 確定選取此 EPC?');
        }

        if (ret) {
            this.props.assignEpcTag(this.props.request.get('category'),
                this.props.view.get('card'),
                epc,
                this.operator);
        }
    }

    confirmLabelId(labelId) {
        if (labelId) {
            this.props.assignEpcTagByLabelId(this.props.request.get('category'),
                this.props.view.get('card'),
                labelId,
                this.operator);
        }
    }

    markAsNotKkProduct() {
        //0, 1
        let catCode = this.props.request.get('category');
        let card = this.props.view.get('card');
        this.props.markAsNotKKProduct(catCode, card, this.operator);
    }

    markAsNoEpc() {
        //0, 1
        let catCode = this.props.request.get('category');
        let card = this.props.view.get('card');
        this.props.markAsNoEpc(catCode, card, this.operator);
    }

    isEpcUndefined() {
        let epc = this.props.rfid.get("epc");
        if (epc) {
            //epc is 'undefined'
            return "NOT_SET" === epc;
        } else {
            //epc is null
            return true;
        }
    }

    hideEpcSetting() {
        return !this.isEpcUndefined();
    }

    showEpc() {
        let epc = this.props.rfid.get("epc");
        if ("NOT_KK_GEAR" === epc) {
            return "非開廣設備";
        } else if ("UNKNOWN" === epc) {
            return "未縫晶片";
        } else {
            return epc;
        }
    }

    showAlreadyDiscard() {
        let alreadyDiscard = this.props.rfid.get("alreadyDiscard");
        if (alreadyDiscard) {
            return "(曾建議不再使用)";
        } else {
            return "";
        }
    }

    showNote() {
        if (this.props.previousView.get('caseModel') && this.props.previousView.get('caseModel').note) {
            return <span>{this.props.previousView.get('caseModel').note}</span>;
        }
        return '';
    }

    showMRecordList() {
        let epc = this.props.rfid.get("epc");
        if (epc.startsWith('302')) {
            this.props.findMRecordList(epc);
        }
    }

    render() {
        let alertDiv = null;
        if ((this.props.alert.get('style') || this.props.alert.get('message'))
            && this.props.alert.get('style') !== 'success') {
            alertDiv = (
                <div style={{ marginTop: 10 }}>
                    <Alert bsStyle={this.props.alert.get('style')} onDismiss={this.props.cleanAlert}>
                        {this.props.alert.get('message')}
                    </Alert>
                </div>
            );
        }

        // 是否為讀取中
        let disableReadRfid = false;
        let readRfidText = "EPC 晶片讀取";
        if (this.props.isLoadingChipEpcs) {
            disableReadRfid = true;
            readRfidText = "EPC 晶片讀取中"
        }

        let bread_crumbs = '';
        if (this.props.view.get('categories') &&
            this.props.view.get('categories')[this.props.request.get('category')]) {
            bread_crumbs = this.props.view.get('categories')[this.props.request.get('category')].description
        }

        let mRecordListDiv = null;
        if (this.props.mRecordList && this.props.mRecordList.size > 0) {
            mRecordListDiv = (
                <div>
                    <SearchMRecordListContainer />
                    <span style={{ color: 'blue' }}>點選列表 <span className="glyphicon glyphicon-list-alt" /> 顯示該筆記錄的「清洗維修明細」</span>
                </div>
            )
        }

        return (
            <div> <span hidden>MaintenanceRfidComponent</span>
                <h4>
                    <img alt='shorts' src='shorts.svg' height="40" width="40" style={this.show(this.props.request.get('category') === 1)} />
                    <img alt='shirt' src='shirt.svg' height="40" width="40" style={this.show(this.props.request.get('category') === 0)} />
                    清點作業管理 &gt;&gt; 洗前清點  &gt;&gt; RFID讀取 &gt;&gt;&nbsp;
                    {this.props.previousView.get('caseModel').orderId}&nbsp;-&nbsp;{this.showNote()}&nbsp;
                    -&nbsp;{this.props.view.get('card').code} - {bread_crumbs}&nbsp;
                    <a onClick={(e) => { this.previousPage() }}><img src="back.png" title="回上一頁" alt="回上一頁" style={{ cursor: 'pointer' }} /></a>
                </h4>
                <br />
                {this.currentSpeedway()} {this.readerHighlight()}&nbsp;
                    <Button title="RFID 讀取機設定"
                        onClick={(event) => { this.showRfidConfig() }}>
                        <img src="gear.svg" height="25" width="25" alt="" />
                    </Button>

                    <div style={{ marginTop: 10 }} hidden={this.isEpcUndefined()}>
                    <b style={{ fontSize: '1.5em' }}>EPC : {this.showEpc()}</b> <b style={{ color: 'orange', fontSize: '1.5em' }}>{this.showAlreadyDiscard()}</b>
                        <br /><br />
                        <Row style={{ paddingTop: 5 }}>
                            <Col xs={12}>
                                <a onClick={() => {
                                    this.showMRecordList();
                                }} style={{ cursor: 'pointer' }}>查看清洗維修記錄</a>
                                {mRecordListDiv}
                            </Col>
                            <Col xs={12}>
                                <Modal bsSize="lg" show={this.props.showModal} onHide={this.props.closeModal} backdrop="static">
                                    <Modal.Header closeButton />
                                    <Modal.Body>
                                        <MaintenanceSearchRecordContainer />
                                    </Modal.Body>
                                </Modal>
                            </Col>
                        </Row>
                    </div>
                    <br />
                    {alertDiv}
                    <div hidden={this.hideEpcSetting()}>
                    <br />
                        <Button bsStyle="info" disabled={disableReadRfid}
                            onClick={(event) => { this.readRfidChips() }}>
                            {readRfidText}
                        </Button>&nbsp;&nbsp;&nbsp;
                        <Button bsStyle="info"
                            onClick={(event) => { this.markAsNotKkProduct() }}>
                            非開廣產品
                        </Button>&nbsp;&nbsp;&nbsp;
                        <Button bsStyle="info"
                            onClick={(event) => { this.markAsNoEpc() }}>
                            未縫晶片
                        </Button>&nbsp;&nbsp;&nbsp;
                        <Table striped bordered condensed hover>
                            <caption>選取 RFID EPC</caption>
                            <thead>
                                <tr>
                                    <th width="10%">&nbsp;</th>
                                    <th>EPC</th>
                                    <th>洗標條碼</th>
                                    <th>衣褲</th>
                                    <th>顏色</th>
                                    <th>選取</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.props.rfid.get('epcs').map(
                                        (item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <label htmlFor={index} >&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <input type="radio" name="epc" id={index} onClick={(e) => { this.confirmEpc(item.epc) }} />
                                                        &nbsp;&nbsp;&nbsp;&nbsp;</label>
                                                </td>
                                                <td>
                                                    <label htmlFor={index} >{item.epc}</label>
                                                </td>
                                                <td>
                                                    <label htmlFor={index} >{item.labelId}</label>
                                                </td>
                                                <td>
                                                    <label htmlFor={index} >{item.gear}</label>
                                                </td>
                                                <td>
                                                    <label htmlFor={index} >{item.color}</label>
                                                </td>
                                                <td>
                                                    <Button
                                                        onClick={(event) => { this.confirmEpc(item.epc) }}>
                                                        選取
                                                    </Button>
                                                </td>
                                            </tr>
                                        )
                                    )
                                }
                            </tbody>
                        </Table>
                        <br /><br /><br /><br /><br /><br />
                        <span><a style={{ 'cursor': 'pointer' }} onClick={() => {
                            this.props.changeShowInputLabelId(true);
                        }}>改用 洗標條碼 (僅在如果無法讀取 RFID EPC 時可直接輸入洗標條碼)</a></span>
                        <div hidden={!this.props.showInputLabelId}>
                        <Table striped bordered condensed hover>
                            <thead>
                                <tr>
                                    <th>洗標條碼</th>
                                    <th>選取</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <FormControl
                                            type="text"
                                            onChange={(event) => {
                                                this.props.changeLabelId(event.target.value)
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <Button
                                            onClick={(event) => { this.confirmLabelId(this.props.labelId) }}>
                                            選取
                                        </Button>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                        </div>
                    </div>

                <Modal show={this.props.view.get('showRfidConfig')} onHide={this.props.hideRfidConfig} backdrop="static">
                    <Modal.Header closeButton >
                        <Modal.Title id="rfid-config">選取/更改 RFID 讀取機</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <RfidSettingContainer />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={(event) => { this.props.hideRfidConfig() }} >離開</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// ./src/components/MaintenanceRfidComponent.jsx